import PropTypes from 'prop-types';
import React from 'react';
import { isFinite } from 'lodash';

import ShopMap from '../../reservation/components/ShopMap';
import { formatDuration } from '../../utils/helpers';

const Info = ({
  barberName,
  serviceName,
  serviceDuration,
  shopName,
  shopAddress,
  shopZip,
  numberInLine,
}) => (
  <div className="layout layout--large u-mt+">
    <div className="layout__item u-1/2-medium-and-up">
      <dl>
        { barberName && [
          <dt className="c-heading c-heading--large">Professional:</dt>,
          <dd className="c-heading c-heading--large u-mb">{barberName}</dd>,
        ]}
        <dt className="c-heading c-heading--large">Service:</dt>
        <dd className="c-heading c-heading--large u-type--capitalize u-mb">{serviceName}</dd>
        <dt className="c-heading c-heading--large">Duration:</dt>
        <dd className="c-heading c-heading--large u-mb">{formatDuration(serviceDuration)}</dd>
        <dt className="c-heading c-heading--large">Shop:</dt>
        <dd className="c-heading c-heading--large">{shopName}</dd>
        <dd className="c-heading c-heading--large">{shopAddress}</dd>
        <dd className="c-heading c-heading--large u-mb">{shopZip}</dd>
        {isFinite(numberInLine) && [
          <dt className="c-heading c-heading--large">Your waitlist position is:</dt>,
          <dd className="c-heading c-heading--large u-mb+">{numberInLine}</dd>,
        ]}
      </dl>
    </div>
    {shopAddress && (
      <div className="layout__item u-1/2-medium-and-up">
        <ShopMap name={shopName} address={shopAddress} />
      </div>
    )}
  </div>
);
Info.propTypes = {
  barberName: PropTypes.string.isRequired,
  serviceName: PropTypes.string.isRequired,
  serviceDuration: PropTypes.number.isRequired,
  shopName: PropTypes.string.isRequired,
  shopAddress: PropTypes.string.isRequired,
  shopZip: PropTypes.string.isRequired,
  numberInLine: PropTypes.number,
};
Info.defaultProps = {
  shopLocation: null,
  numberInLine: null,
};

export default Info;



// WEBPACK FOOTER //
// ./src/app/waitingList/components/Info.jsx